module.exports = __webpack_public_path__ + "img/ben-kw-01.54ecfc50.jpg";